<template>
    <div>
        <el-table
            v-if="isLoading === false"
            :data="tableData"
            style="width: 100%"
            class="pollen-lab-quality-control-table"
            size="mini"
            :header-cell-style="{ background: '#F5F7FA' }"
            border
        >
            <el-table-column
                type="index"
                width="30"
            />
            <el-table-column
                prop="testDate"
                label="Test Date"
                min-width="130"
            />
            <el-table-column
                prop="testingStage"
                label="Stage"
                min-width="40"
            />
            <el-table-column
                prop="weight"
                label="Weight (g)"
                min-width="75"
            />
            <el-table-column
                prop="viabilityPercentage"
                label="Viability (%)"
                min-width="75"
            />
        </el-table>
        <p v-else>Loading...</p>
    </div>
</template>

<script>
import { pollenBottleViabilityTestGetAll } from "@/api/pollen_bottle_viability_test";

export default {
    props: {
        pollenBottleId: {
            type: String | Number
        }
    },
    data() {
        return {
            tableData: [],
            isLoading: false,
        };
    },
    watch: {
        pollenBottleId: {
            immediate: true,
            handler() {
                this.getPollenBottles();
            },
        },
        isLoading() {
            if (this.isLoading === true) {
                this.tableData = [];
            }
        }
    },
    methods: {
        async getPollenBottles () {
            this.isLoading = true;
            let res = await pollenBottleViabilityTestGetAll({ "PollenBottleId": this.pollenBottleId });
            if (res) {
                this.tableData = res.items;
            }
            this.isLoading = false;
        }
    },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/PollenBottle/PollenLabQualityControlSimpleTable.vue